import { FeedbackEntry } from "@/types/types";
import { onAuthStateChanged } from "firebase/auth";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../standard/firebase";

const getInterviewFeedback = async () => {
  return new Promise<Array<FeedbackEntry> | null>(async (resolve) => {
    onAuthStateChanged(auth, async (user) => {
      const userUID = auth.currentUser?.uid;

      if (!userUID) {
        resolve(null);
        return;
      }

      const userRef = doc(db, "users", userUID);
      const docSnapshot = await getDoc(userRef);

      if (docSnapshot.exists()) {
        const userData = docSnapshot.data();
        resolve(userData.feedback);
      }

      resolve(null);
    });
  });
};

const checkUserStatus = () => {
  return new Promise<boolean>((resolve) => {
    onAuthStateChanged(auth, (user) => {
      resolve(!!user);
    });
  });
};

const checkInterviewStatus = async () => {
  return new Promise<number>(async (resolve) => {
    onAuthStateChanged(auth, async (user) => {
      const userCollectionRef = collection(db, "users");
      const userUID = auth.currentUser?.uid;

      if (!userUID) {
        resolve(0); // Return 0 if no UID is found
        return;
      }

      // Create a query to find the document with the matching UID
      const q = query(userCollectionRef, where("uid", "==", userUID));

      // Execute the query to get the user document
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Get the first document (assuming UID is unique)
        const userDocRef = querySnapshot.docs[0];
        const userData = userDocRef.data();

        if (userData.purchased) resolve(2);
        if (userData.demo > 0) resolve(1);
      }

      resolve(0);
    });
  });
};

const expendCredit = async () => {
  return new Promise<number>(async (resolve) => {
    onAuthStateChanged(auth, async (user) => {
      const userUID = auth.currentUser?.uid;

      if (!userUID) {
        resolve(0); // Return 0 if no UID is found
        return;
      }

      const userRef = doc(db, "users", userUID);
      const docSnapshot = await getDoc(userRef);

      if (docSnapshot.exists()) {
        // Get the first document (assuming UID is unique)
        const userData = docSnapshot.data();

        userData.demo -= 1;
        await setDoc(userRef, userData);
      }

      resolve(0);
    });
  });
};

const addInterviewFeedback = async (feedback) => {
  return new Promise<number>(async (resolve) => {
    onAuthStateChanged(auth, async (user) => {
      const userUID = auth.currentUser?.uid;

      if (!userUID) {
        resolve(0);
        return;
      }

      const userRef = doc(db, "users", userUID);
      const docSnapshot = await getDoc(userRef);

      if (docSnapshot.exists()) {
        for (const data of feedback) {
          const userData = {
            feedback: arrayUnion(data),
          };

          await updateDoc(userRef, userData);
        }
        console.log(feedback);
      }

      resolve(0);
    });
  });
};

const getUserCredits = async () => {
  return new Promise<number>(async (resolve) => {
    onAuthStateChanged(auth, async (user) => {
      const userCollectionRef = collection(db, "users");
      const userUID = auth.currentUser?.uid;

      if (!userUID) {
        resolve(0); // Return 0 if no UID is found
        return;
      }

      // Create a query to find the document with the matching UID
      const q = query(userCollectionRef, where("uid", "==", userUID));

      // Execute the query to get the user document
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Get the first document (assuming UID is unique)
        const userDocRef = querySnapshot.docs[0];
        const userData = userDocRef.data();

        resolve(userData.demo);
      }

      resolve(0);
    });
  });
};

export {
  addInterviewFeedback,
  checkInterviewStatus,
  checkUserStatus,
  expendCredit,
  getInterviewFeedback,
  getUserCredits,
};
